import { useRef, useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TabPage from "../../components/tab/tabPage";
import CommonPageLayout from "../../components/commonPageLayout/commonPageLayout";
import CustomButton from "../../components/CustomButton/Button";
import {
  Box,
  Alert
  } from "@mui/material";
import axios from "axios";
import MemberPointsTab from "../MemberPoints/MemberPointsPage";
import MemberCreditsTab from "../MemberCredits/MemberCreditsPage";
import { GET_USER_BY_ID_PATH } from "../../constants/apipaths";
import { useAppSelector } from "../../redux/hooks";

interface Member {
  UserId: string;
  NAME?: string;
  Email?: string;
  Mobile?: string;
  DateOfBirth?: string;
  PostCode?: string | null;
  DateSignUp?: string;
  DateLastActivity?: string;
  Credits?: string;
  Points?: string;
  HasEmail?: number;
}

function MemberDetailsPage() {
  const tabsRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const { userId } = useParams();
  const [member, setMember] = useState<Member | null>(null);

  let currentBusiness: any = localStorage?.getItem("currentBusiness");
  const state: any = {
    token: localStorage?.getItem("businessAccessToken"),
    currentBusiness: currentBusiness ? JSON.parse(currentBusiness) : null
  };

  // Global billing / restriction state from Redux
  const { isNonPaying } = useAppSelector((s) => s.businessAccess);

  const fetchMemberDetails = useCallback(() => {
    if (!userId || !state?.token) return;
    
    const url = `${process.env.REACT_APP_API_BASE_URL}${GET_USER_BY_ID_PATH}/${userId}`;
    
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${state.token}`,
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const userData = response.data;
        
        // Map the API response to the Member interface
        if (userData) {
          setMember({
            UserId: userId,
            NAME: userData.NAME,
            Mobile: userData.Mobile,
            Email: userData.Email,
            DateOfBirth: userData.DateOfBirth,
            PostCode: userData.PostCode,
            DateSignUp: userData.DateSignUp,
            DateLastActivity: userData.DateLastActivity,
            Credits: userData.Credits,
            Points: userData.Points,
            HasEmail: userData.HasEmail
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [userId, state?.token]);

  useEffect(() => {
    fetchMemberDetails();
  }, [fetchMemberDetails]);

  const handleBackToMembers = () => {
    navigate("/members");
  };

  const getMemberName = () => {
    return member?.NAME ?? "";
   
  };

  const tabs = [
    {
      label: "Points",
      value: "1",
      component: userId ? <MemberPointsTab userId={userId} /> : null
    },
    {
      label: "Credits",
      value: "2",
      component: userId ? <MemberCreditsTab userId={userId} /> : null
    }
  ];

  const docsContent = (
    <Box display="flex" gap={2} alignItems="center" justifyContent="flex-end">
      <CustomButton callBack={handleBackToMembers}>Back</CustomButton>
    </Box>
  );

  // Fetch member details to display member name in heading

  return (
    <>
      <CommonPageLayout
        heading={getMemberName()}
        subHeading="Member Details"
        docs={docsContent}
      >
        {isNonPaying && (
          <Box sx={{ mb: 2 }}>
            <Alert severity="error">
              Access limited: Please renew your contract or fix payment issues
              to view member details.
            </Alert>
          </Box>
        )}
        <TabPage
          tabsRef={tabsRef}
          tabs={tabs}
          defaultTab="1"
          showRefresh={false}
          onTabChange={() => {}}
        />
      </CommonPageLayout>
    </>
  );
}

export default MemberDetailsPage;

